import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface Member {
  id: number
  name: string
  email: string
  role: string
}

export const getMembersByPrivateProject = async (
  projectId: number,
  config?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<Member[]>(
    `${apiRoutes.getMembersByProject}/${projectId}`,
    config,
  )

  return data
}
